<script setup lang="ts">
import ScreenTimeCard from "@/components/ScreenTimeCard.vue";
import type { ScreenTimeEntry } from "@/types/protocol";

defineProps<{ entries: readonly ScreenTimeEntry[] }>();
</script>

<template>
  <section>
    <h2>Bildschirmzeit heute</h2>
    <div v-if="entries.length" class="grid">
      <ScreenTimeCard v-for="entry in entries" :key="entry.user" :entry="entry" />
    </div>
    <div v-else class="empty">Heute noch keine Bildschirmzeit erfasst.</div>
  </section>
</template>

<style scoped>
.grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
}
</style>
